import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../auth/services/auth.service';
import { LegalNoticeItemModel } from '../../models/legal-notice-item.model';
import { LegalNoticeResponseModel } from '../../models/legal-notice-response.model';
import { LegalNoticeService } from '../../services/legal-notice.service';

@Component({
  selector: 'legal-notice-page',
  templateUrl: './legal-notice-page.component.html',
})
export class LegalNoticePageComponent implements OnInit {

  public items: LegalNoticeItemModel[] = [];
  public logoSize: string = 'logo-medium';
  public guest: boolean = true;
  public contentCategoryTitle: string = '';

  private category: string = null;

  /**
   * Constructor
   *
   * @param {LegalNoticeService} legalNoticeService
   * @param {Router} router
   * @param route
   * @param {AuthService} authService
   */
  public constructor(
    private legalNoticeService: LegalNoticeService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService) {
  }

  /**
   * Initialize the Component
   *
   * @return void
   */
  public ngOnInit(): void {

    this.route.params.subscribe(params => {
      this.getItems(params.category);

    });

    AuthService.isAuthenticated().subscribe(
      (playerAuthenticated) => {
        this.guest = !playerAuthenticated;
      },
    );
  }

  /**
   * Get the Legal Notice Items
   *
   * @param {string} category
   */
  private getItems(category: string): void {
    this.legalNoticeService.getItemList(category).subscribe((response: LegalNoticeResponseModel) => {
      this.items = response.contentItems;

      this.contentCategoryTitle = response.categoryTitle;

      if (this.items.length === 0) {
        this.router.navigate(['/']).then();
      }

    });
  }

}
